
import React from "react";
import { i18nManager } from "../../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import Notifications from "../../../shared/Notifications";
import { NotificationGroup } from "../../../shared/Notifiier";
import { ApiResponseData, BaseService, TournamentService, INotification, ITournamentEditionRegistered, MemberNotificationService, SanitizedResponse, TeamService, ITournamentEditionMatch, TournamentMatchStatus, ITournamentEditionRegisteredParticipant } from "../../../../services";
import { ConfirmDialog, Siren } from "../../../shared/ConfirmDialog";
import { AlertInterface, Checkbox, DOMHelper, ScrollPanel, useSubscription } from "@rivtn/noseur";
import { Elements } from "../../../shared/Elements";
import { Schemes, Utils } from "../../../../utils";
import MatchCard, { showTournamentPass } from "./shared/MatchCard";
import Match from "./shared/Match";

export interface YourTourMatchesAndReportingProps {
    registeredTournamentParticipant: ITournamentEditionRegisteredParticipant;
}

function YourTourMatchesAndReporting(props: YourTourMatchesAndReportingProps) {

    const { registeredTournamentParticipant } = props;
    const tournamentService = TournamentService.getInstance();
    const [matches, setMatches] = React.useState<ITournamentEditionMatch[]>();
    const labels = i18nManager.Labels.tournaments.your_tournament.matches_and_reporting;
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const tournamentEdition = registeredTournamentParticipant.tournament_edition_registered.tournament_edition;
    const [selectedMatch, setSelectedMatch] = React.useState<{ match: ITournamentEditionMatch; action?: string; }>();
    useSubscription("OMNEHOST.YOUR_TOUR.MATCH.UNSELECT", setSelectedMatch);

    React.useEffect(fetchInformation, []);

    if (selectedMatch) {
        return (<Match match={selectedMatch.match} tournamentEditionRegisteredParticipantId={registeredTournamentParticipant.external_id} action={selectedMatch.action} tournamentName={tournamentEdition.name}
            reloadMatch={() => {
                setMatches(undefined);
                setSelectedMatch(undefined);
                fetchInformation();
            }} />)
    }

    return (<div className="your-tour-home your-tour-mar">
        <div className="snapper" style={{ justifyContent: "space-between", marginTop: 10 }}>
            <div>
                <Checkbox scheme={Schemes.OMNEHOST} defaultChecked={!searchParams.get("filter") || searchParams.get("filter")?.includes("ENDED") || searchParams.get("filter")?.includes("CANCELLED") || searchParams.get("filter")?.includes("FORFEITED")}
                    label={labels.show_past_matches} onChecked={(checked) => {
                        updateSearchQuery(checked, ["ENDED", "CANCELLED", "FORFEITED"]);
                    }} />
                <Checkbox scheme={Schemes.OMNEHOST} defaultChecked={!searchParams.get("filter") || searchParams.get("filter")?.includes("ONGOING")} label={labels.show_ongoing_matches} style={{ marginTop: 15 }} onChecked={(checked) => {
                    updateSearchQuery(checked, ["ONGOING"]);
                }} />
                <Checkbox scheme={Schemes.OMNEHOST} defaultChecked={!searchParams.get("filter") || searchParams.get("filter")?.includes("UPCOMING")} label={labels.show_upcoming_matches} style={{ marginTop: 15 }} onChecked={(checked) => {
                    updateSearchQuery(checked, ["UPCOMING"]);
                }} />
            </div>
        </div>
        <div className="container">
            <div className="uo-matches" style={{ marginRight: 0 }}>
                <ScrollPanel className="matches" style={{ marginTop: 0 }}>
                    {(!matches) && (Elements.LOADING_STATE)}
                    {matches && !matches?.length && (Elements.buildEmptyListView("fa fa-list", (<>
                        <span>{labels.no_match_found}</span>{" "}
                    </>)))}
                    {(matches && matches.length > 0) && (matches.map((match, i) => (<MatchCard key={DOMHelper.uniqueElementId("mcmatch")}
                        tournamentEditionRegisteredParticipantId={registeredTournamentParticipant.external_id} match={match} tournamentName={tournamentEdition.name} onAction={(match, action) => {
                            Utils.updateSearchParamses({ mid: match.external_id, a: action }, setSearchParams);
                            setSelectedMatch({ match, action });
                        }} />)))}
                </ScrollPanel>
            </div>
        </div>
    </div>);

    function fetchInformation() {
        const mid = searchParams.get("mid");
        tournamentService.queryRegisteredTournamentMatches(registeredTournamentParticipant.tournament_edition_registered.tournament_edition.external_id, {
            sort: "start_date,DESC",
            "participants.resolve": true,
            status__in: searchParams.get("filter")?.split(","),
            "tournament_edition_registered_participant_ids": registeredTournamentParticipant.external_id,
        }).then(({ content }: SanitizedResponse<ITournamentEditionMatch>) => {
            const done = () => setMatches(content!);
            if (mid) {
                for (const match of content!) {
                    if (match.external_id === mid) {
                        setSelectedMatch({ match, action: searchParams.get("a") ?? undefined });
                        done();
                        break;
                    }
                }
                // get mach by id
                return;
            }
            done();
        }).catch(BaseService.reportError);
    }

    function updateSearchQuery(checked: boolean, keys: string[]) {
        const filters = [...((searchParams.get("filter") ?? "ENDED,CANCELLED,FORFEITED,ONGOING,UPCOMING").split(",") ?? [])].filter((f) => !!f);
        for (const key of keys) {
            if (checked) filters.push(key);
            else filters.splice(filters.indexOf(key), 1);
        }
        Utils.updateSearchParams("filter", Array.from(new Set(filters)).join(","), setSearchParams, fetchInformation);
    }

}

export default YourTourMatchesAndReporting;
